<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row" style="display: flex !important;">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="{{ messageService.get_search() }}" autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div class="service_pager">
            <span>
                <div class="video_div1" (click)="open_video()" *ngIf="video">
                    <mat-icon class="video">smart_display</mat-icon>
                </div>
                <div class="pager_pe">
                    <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-forward"></i></button>
                    <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-backward"></i></button>
                </div>
                <div class='navigation'><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
                <span class="title header_other" *ngIf="user_title">
                    گزارش پرسنل {{ user_title }}
                </span>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox">
            <div class="pager_icon_en">
                <div class="excel">
                    <img src="../../../../../assets/images/excel.png" class="excel_icon cursor"
                        (click)="load_data(1,2,1,-1)">
                    <a href="" id="excel"><i class="far fa-file-excel" [hidden]="true"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content-body control-content-body" (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" class='matTable table-scroll mat_table_fa_without_scroll_bg pe1'>

        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:45px'>
                <span>#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:45px'>{{ i +
                page_number_first }}</mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:45px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef style="text-align: center !important;" style="max-width:100px">
                <span>تاریخ سند</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:100px" (click)="order_ref(i)">
                {{ x.finance_financial2_date }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:100px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="document">
            <mat-header-cell *matHeaderCellDef style="min-width:480px">
                <span>شرح</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="min-width:480px" (click)="order_ref(i)">
                <div class="right">
                    <span>
                        {{ x.alias }}
                        <span> {{ x.finance_payment_type_title }} </span>
                        <span>
                            <span *ngIf="x.finance_financial2_ref == 3">
                                بابت پذیرش
                            </span>
                            <span *ngIf="x.finance_financial2_ref == 2">
                                بابت فاکتور {{ x.type_title }}
                            </span>
                            <span *ngIf="x.finance_financial2_ref == 1 || x.finance_financial2_ref == 4">
                                براساس سند شماره
                            </span>
                        </span>
                        <span *ngIf="x.finance_financial2_ref == 1 || x.finance_financial2_ref == 4"> {{
                            x.id }}</span>
                        <span *ngIf="x.finance_financial2_ref == 3"> {{
                            x.id2 }}</span>
                        <span *ngIf="x.finance_financial2_ref == 2"> {{
                            x.wharehouse_invoice_number }}</span>
                    </span>

                    <div class="invoice_type_title fleft">
                        {{ x.type_title }}
                    </div>
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='min-width:480px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="bed">
            <mat-header-cell *matHeaderCellDef>
                <span>بدهکار</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="order_ref(i)">
                <div class="right">
                    <span class="amount">{{x.bed | number }}</span>
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>
                <div class="right">
                    <span class="amount">{{ bed | number }}</span>
                </div>
            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="best">
            <mat-header-cell *matHeaderCellDef>
                <span>بستانکار</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index">
                <div class="right fright">
                    <span class="amount">{{x.best | number }}</span>
                </div>
                <div class="left" [matMenuTriggerFor]="menu"
                    (click)="check_material(x.finance_financial2_order_id,x.wharehouse_order_material_type)"
                    *ngIf="x.finance_financial2_type_ref2 > 0"><i class="fas fa-info-circle icon"></i></div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>
                <div class="row">
                    <div class="right">
                        <span class="amount">{{ best | number }}</span>
                    </div>
                </div>
            </mat-footer-cell>
        </ng-container>
        <mat-menu #menu="matMenu" class="cardex-mat-menu-panel" xPosition="before">
            <div class="div_loading">
                <div class="my-container" [hidden]="!loading2">
                    <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
                </div>
            </div>
            <table class="table table-bordered" (click)="$event.stopPropagation()">
                <tr>
                    <td class="right">
                        <span>
                            <span *ngIf="amount >= 0">مبلغ سود این رکورد</span>
                            <span *ngIf="amount < 0" class="alarm">مبلغ زیان این رکورد</span>
                        </span>
                    </td>
                    <td> <span class="amount" [ngClass]="{alarm:amount < 0}">{{ amount | number
                            }}</span> </td>
                </tr>
                <tr>
                    <td class="right">
                        <span> تخفیف </span>
                    </td>
                    <td> <span class="amount">{{ discount | number
                            }}</span> </td>
                </tr>
                <tr>
                    <td class="right">
                        <span> درصد محاسبه شده </span>
                    </td>
                    <td> {{ profit | number }} </td>
                </tr>
            </table>
        </mat-menu>

        <ng-container matColumnDef="remain">
            <mat-header-cell *matHeaderCellDef>
                <span>مانده</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="order_ref(i)">
                <div class="money">{{ x.remain2 | number }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>
                <div>{{ remain | number }}</div>
            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="comment">
            <mat-header-cell *matHeaderCellDef>
                <span>توضیحات</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="order_ref(i)">
                <div class="right">{{ x.comment2 }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>
                <div></div>
            </mat-footer-cell>
        </ng-container>

        <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
        </mat-header-row>
        <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
            (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor"></mat-row>
        <mat-footer-row style="background: rgb(245 245 163) !important;bottom:-2px"
            *matFooterRowDef="displayedColumns;sticky : true">
        </mat-footer-row>
    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets/images/preview2.png">
            </div>
            <div class="preview2">{{ messageService.get_no_record_text() }}</div>
        </div>
    </div>
</div>